import React, {Component} from "react";
import PropTypes from "prop-types";

const propTypes = {
	selected: PropTypes.bool.isRequired,
	setCoords: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	code: PropTypes.number.isRequired,
	description: PropTypes.string
}

class ZoneItem extends Component {
	render() {
		return (<div className={`zone-item ${this.props.selected && 'selected'}`} onClick={() => this.props.setCoords(this)}>
			<h3>{this.props.name}</h3>
			<p className="code">
				<span>Código: </span>
				{this.props.code}
			</p>
			<div className="content" dangerouslySetInnerHTML={{__html: this.props.description}} />
		</div>);
	}
}

ZoneItem.propTypes = propTypes;

export default ZoneItem;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/maps/zone-item.jsx